import globals from '../../globals'
import {
    REQUEST_CHECK_LOGGED_IN,
    REQUEST_GET_CUSTOMER,
    SET_ACCESS_TOKEN,
    SET_EXCHANGE_TOKEN,
    SET_REDIRECT_TO,
    CLEAR_REDIRECT_TO,
    ACTION_LOGOUT,
    SET_VERIFIED_USER,
    SET_MFA_VALIDATED
} from '../actions'

const initialState = {
    isLoggedIn: null,
    id: '',
    firstName: '',
    lastName: '',
    fullName: '',
    contactEmail: '',
    paymentVia: '',
    displayPaymentVia: '',
    accountNumber: '',
    token: '',
    exchangeToken: '',
    loggedInAt: '',
    accountBalance: '',
    persistLogin: false,
    homeSecureBeta: false,
    mobileBeta: false,
    validIdCheck: false,
    residential: true,
    mfaEnabled: true,
    isMfaChecked: false
}

export default (state = initialState, action) => {
    switch (action.type) {
    case REQUEST_CHECK_LOGGED_IN:
        return {
            ...state,
            isLoggedIn: action.payload.isLoggedIn
        }
    case REQUEST_GET_CUSTOMER:
        if (!action.payload) {
		        return state
        }

        // If the user is business, set a GA dimension so they can be measured separately in GA
        if (!action.payload.residential) {
            globals.pushEvent('smb_customer_myexetel', { dimension1: true })
        }

        const paymentVia = `${action.payload.paymentVia} ${action.payload.accountNumber && action.payload.accountNumber.length > 0 ? `****${action.payload.accountNumber.substr(action.payload.accountNumber.length - 4)}` : ''}`

        let displayPaymentVia = '';
        if (action.payload.displayPaymentVia) {
            displayPaymentVia = `${action.payload.displayPaymentVia} ${action.payload.accountNumber && action.payload.accountNumber.length > 0 ? `****${action.payload.accountNumber.substr(action.payload.accountNumber.length - 4)}` : ''}`;
        }

        return {
            ...state,
            id: action.payload.id,
            firstName: action.payload.firstName,
            lastName: action.payload.lastName,
            fullName: action.payload.fullName,
            contactEmail: action.payload.contactEmail,
            contactMobile: action.payload.contactMobile,
            paymentVia: paymentVia,
            displayPaymentVia: displayPaymentVia,
            accountBalance: parseFloat(action.payload.accountBalance),
            homeSecureBeta: action.payload.homeSecureBeta,
            mobileBeta: action.payload.mobileBeta,
            validIdCheck: action.payload.validIdCheck,
            residential: action.payload.residential,
            mfaEnabled: action.payload.mfaEnabled
        }
    case SET_ACCESS_TOKEN:
        return {
            ...state,
            token: action.payload.token,
            persistLogin: action.payload.persistLogin,
            loggedInAt: Date.now(),
            isLoggedIn: true
        }
    case SET_EXCHANGE_TOKEN: 
        return {
            ...state,
            exchangeToken: action.payload.exchangeToken
        }    
    case SET_REDIRECT_TO:
        return {
            ...state,
            redirectTo: action.payload
        }
    case CLEAR_REDIRECT_TO:
        return {
            ...state,
            redirectTo: ''
        }
    case ACTION_LOGOUT:
        return {
            ...state,
            isLoggedIn: false,
            id: '',
            firstName: '',
            lastName: '',
            fullName: '',
            contactEmail: '',
            paymentVia: '',
            accountNumber: '',
            token: '',
            accountBalance: '',
            homeSecureBeta: false,
            mobileBeta: false,
            validIdCheck: false,
            residential: true,
            isMfaChecked: false,
            mfaEnabled:false
        }
    case SET_VERIFIED_USER:
        return {
            ...state,
            isVerified: action.payload
        }
    case SET_MFA_VALIDATED:
        return {
            ...state,
            isMfaChecked: true
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./resources/js/redux/reducers/authReducer.js